import { initializeApp } from 'firebase/app';
import { getAnalytics } from "firebase/analytics";
import { 
    getAuth, 
    signInWithPopup, 
    GoogleAuthProvider,
    signOut,
    onAuthStateChanged
} from 'firebase/auth';
import { 
    getFirestore,
    doc,
    getDoc,
    setDoc,
    collection,
    writeBatch
} from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyBwP4X93NenB7DcaZAf6cFor04yQxtG_Ug",
    authDomain: "tree-f3444.firebaseapp.com",
    projectId: "tree-f3444",
    storageBucket: "tree-f3444.appspot.com",
    messagingSenderId: "590219812846",
    appId: "1:590219812846:web:269d67490f273870bd78ff",
    measurementId: "G-CM3H3FYPW9"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const firebaseApp = initializeApp(firebaseConfig);

const provider = new GoogleAuthProvider();

provider.setCustomParameters(
    {
        prompt : "select_account"
    }
);

export const auth = getAuth();

export const signInWithGooglePopup = () => signInWithPopup(auth, provider);

export const db = getFirestore();

export const addCollectionAndDocuments = async (collectionKey, objectsToAdd) => {
    const collectionRef = collection(db, collectionKey);
    const batch = writeBatch(db);

    objectsToAdd.forEach((object) => {
        const docRef = doc(collectionRef, object.title.lowerCase());
        batch.set(docRef, object);
    });

    await batch.commit();
    console.log('done') 
};

export const createUserDocumentFromAuth = async (userAuth) => {
    const userDocRef = doc(db, 'users', userAuth.uid);

    // console.log(userDocRef)

    const userSnapshot = await getDoc(userDocRef);
    // console.log(userSnapshot)
    // console.log(userSnapshot.exists());

    if(!userSnapshot.exists()) {
        const { displayName, email, photoURL } = userAuth;
        const createdAt = new Date();
        const username = email.split("@")[0];
        // const id = displayName.replace(/\s/g, '');

        try {
            await setDoc(userDocRef, {
                username,
                displayName,
                email,
                photoURL,
                createdAt
            });
        } catch (error) {
            console.log('error creating', error.message)
        }
    } 

    return userDocRef;
}

export const signOutUser = () => signOut(auth);

export const onAuthStateChangedListener = (callback) => 
    onAuthStateChanged(auth, callback);